// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"c10b0a19","94":"163ab38d","117":"170cd41e","477":"8b84be5f","786":"bd83aa42"}[chunkId] + ".css";
};